import React, { Fragment, useState } from "react";
import "./css/_shortForm.scss";
import UseShortFormQuery from '@staticQueries/shortFormQuery';
import FormFields from "./FormFields";
import Loader from "../Loader/Loader";

export default function ShortForm({storeId, zip, showModal, handleCloseModal}) {
     
    const [loading, setLoading] = useState(false);
    const [submissionComplete, setSubmissionComplete] = useState(null);
    const kontent = UseShortFormQuery(); 
  return (
    <Fragment> 
        <div className={`modal-short-form modal fade ${showModal ? 'show' : ''}`} style={{display: "block"}} id="shortForm" tabIndex="-1" role="dialog" aria-labelledby="shortFormLabel" >
            <div className="modal-dialog " role="document">
                <div className="modal-content">
                <div className="modal-header close-btn">
                    <button type="button" className="btn btn-close-modal" data-dismiss="modal" onClick={() => handleCloseModal() }>X</button>
                </div>
                <div className="modal-body">
 
                    {
                        (loading) ?  ( <Loader /> ) : <></>
                    }
                    {
                        ( loading === false && submissionComplete === null) ? 
                            (
                                <FormFields
                                    storeId={storeId}
                                    zip={zip}
                                    setLoading={setLoading}
                                    setSubmissionComplete={setSubmissionComplete}
                                />
                            )
                        : <></>
                    }
                    {
                        (submissionComplete) ?  
                        ( 
                            <Fragment>
                                <h4 className="text-center">{submissionComplete.title}</h4>
                                <p className="text-center">{submissionComplete.message}</p>
                            </Fragment>
                        ) 
                        : <></>
                    }
                    
                </div>
                <div className="modal-footer">
                    <div className="legal-short" dangerouslySetInnerHTML={{ __html: kontent.legal.value}}></div>
                </div>
                </div>
            </div>
        </div>
    </Fragment>
  )
}
